import { Stack } from "@mui/material";
import { useMedicalCareContext } from "../../../../contexts/MedicalCareContext";

import { useQuestionnaireContext } from "../../../../contexts/QuestionnaireContext";
import { SocialFields } from "./SocialFields";
import { SocialHistory } from "./SocialHistory";
import { scrollbarStyle } from "../scrollbarStyle";
import LuxorMed from "@/components/luxor/LuxorMed";

export function SocialHabits() {
  const { loadingResponse } = useQuestionnaireContext();
  const { patient, luxorMode } = useMedicalCareContext();
  return (
    <Stack width="100%" direction="row">
      <Stack width="50%">
        <SocialFields />
      </Stack>
      {!loadingResponse && (
        <Stack
          maxHeight="60vh"
          width="60%"
          overflow="auto"
          sx={{
            ...scrollbarStyle,
          }}
        >
          {!luxorMode && (
            <SocialHistory />
          )}
          {luxorMode && (
            <LuxorMed />
          )}
        </Stack>
      )}
    </Stack>
  );
}
